// src/pages/MessageLayout.js
import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

export default function MessageLayout({ message, type }) {
  if (type === "loading") {
    return (
      <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-slate-50 px-4 text-center">
        <div className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 shadow-[0_30px_80px_-60px_rgba(15,23,42,0.65)]">
          <p className="section-eyebrow">VdoPage</p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">
            {message || "Loading"}
          </h1>
          <div className="mt-6 grid gap-3">
            <div className="h-3 animate-pulse rounded-full bg-slate-200" />
            <div className="mx-auto h-3 w-3/4 animate-pulse rounded-full bg-slate-200" />
          </div>
          <p className="mt-6 text-sm text-slate-500">Powered by VdoPage.com</p>
        </div>
      </div>
    );
  }

  if (type === "error") {
    return (
      <div className="flex min-h-[100dvh] items-center justify-center bg-slate-50 px-4">
        <div className="max-w-md rounded-xl border border-rose-200 bg-white p-6 shadow-[0_30px_80px_-60px_rgba(15,23,42,0.65)]">
          <div className="flex gap-4">
            <div className="grid h-11 w-11 flex-none place-items-center rounded-lg bg-rose-50 text-rose-600">
              <ExclamationTriangleIcon aria-hidden="true" className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-slate-950">
                {message || "Video not found"}
              </h3>
              <p className="mt-2 text-sm leading-6 text-slate-600">
                Check that the URL is correct. If you own this page, review its publish status and settings.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
